const themes = {
  brand: {
    'primary':                   { light: '#2a244e', dark: '#2a244e' },
    'primaryOl':                 { light: '#6428BD', dark: '#5555A5' },
    'secondary':                 { light: '#63ffd3', dark: '#43aa8b' },
    'tertiary':                  { light: '#4D4090', dark: '#4D4090' },
    'accent':                    { light: '#D02540', dark: '#D02540' },
    'background':                { light: '#f4f4f4', dark: '#1f1f1f' },
    'foreground':                { light: '#504F4F', dark: '#e0e0e0' },
    'foreground-accent':         { light: '#f4f4f4', dark: '#e0e0e0' },
  },

  components: {
    'muted':                     { light: '#ffffff', dark: '#303030' },
    'muted-accent':              { light: '#f5f5f5', dark: '#6b6b6b' },

    'btnprimary':                { light: '#e53a5d', dark: '#e53a5d' },
    'footer':                    { light: '#eeeeee', dark: '#111719' },

    'quote':                     { light: '#5fd3c7', dark: '#e0e0e0' },
    'quote-btn-border':          { light: '#63ffd3', dark: '#63ffd3' },
    'quote-btn-border-disabled': { light: '#808080', dark: '#6b6b6b' },
    'quote-btn-background':      { light: '#262626', dark: '#1f1f1f' },

    'building':                  { light: '#65FDD4', dark: '#65FDD4' },
    'people':                    { light: '#6428BD', dark: '#6428BD' },
  },

  other: {
    'success':                   { light: '#2a244e', dark: '#2a244e' },
    'red':                       { light: '#E62739', dark: '#E62739' },
    'blue':                      { light: '#0476D0', dark: '#0476D0' },
    'darkblue':                  { light: '#00008b', dark: '#00008b' },
    'green':                     { light: '#18A558', dark: '#18A558' },
    'shadow':                    { light: '#6B6B6B', dark: '#000000' },

    'title-icon':                { light: '#63ffd3', dark: '#63ffd3' },
    'title-icon-background':     { light: '#1f1f1f', dark: '#1f1f1f' },
    'title-foreground':          { light: '#512198', dark: '#63ffd3' },
  },

  inputs: {
    'input':                     { light: '#e0e0e0', dark: '#303030' },
    'border':                    { light: '#e0e0e0', dark: '#6B6B6B' },
  },
}

const flatten = (mode) => Object.values(themes)
  .reduce((merged, group) => ({
    ...merged,
    ...Object.entries(group).reduce((grouped, [theme, value]) => ({
      ...grouped,
      [theme]: value[mode],
    }), {}),
  }), {});

export const lightTheme = flatten('light');
export const darkTheme = flatten('dark');
export const groupedThemes = Object.keys(themes).reduce((acc, key) => ({
  ...acc,
  [key]: Object.keys(themes[key]),
}), {});

export default themes;
